import { LookupValues } from 'src/utils/types';

export const SUPPORTED_HTTP_METHODS = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
    PUT: 'PUT',
} as const;
export type SupportedMethod = LookupValues<typeof SUPPORTED_HTTP_METHODS>;

export const SUPPORTED_CONTENT_TYPES = {
    TEXT: 'text/plain',
    JSON: 'application/json',
    FORM_DATA: 'multipart/form-data',
    URL_FORM_ENCODED: 'application/x-www-form-urlencoded',
};

export const RESPONSE_TYPES = {
    NETWORK_ERROR: 'NetworkError',
    RESOLVED: 'Resolved',
} as const;
export type ResponseType = LookupValues<typeof RESPONSE_TYPES>;

export const DEFAULT_TIMEOUT = 30000;
// see http://stackoverflow.com/questions/417142/what-is-the-maximum-length-of-a-url-in-different-browsers
export const MAX_URL_LENGTH = 2047;
